import FuelReportView from "./views/FuelReportView.vue";

const authRoutes = [
    {
        path: '/fuel-report',
        component: FuelReportView,
        name: 'FuelReport',
        meta: { requiresAuth: true },

    }
]

export default router => {
    authRoutes.forEach(route => {
        router.addRoute(route);
    });
}